import { Component, Injector, Input, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor, NgControl, NG_VALIDATORS, Validator, AbstractControl, ValidationErrors } from '@angular/forms';
import { parsePhoneNumberFromString, CountryCode, getExampleNumber, PhoneNumber } from 'libphonenumber-js';
import examples from 'libphonenumber-js/examples.mobile.json';
import { COUNTRIES_EN, COUNTRIES_FR, Country } from '@core-lib/models/country.model';

@Component({
    selector: 'app-custom-phone-input',
    templateUrl: './custom-phone-input.component.html',
    styleUrls: ['./custom-phone-input.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => CustomPhoneInputComponent),
            multi: true
        },
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => CustomPhoneInputComponent),
            multi: true
        }
    ],
    standalone: false
})
export class CustomPhoneInputComponent implements ControlValueAccessor, Validator {

  @Input() id: string;
  @Input() isToConsult: boolean = false;
  @Input() set selectedCountryISO(value: string) {
    if(value){
      this.selectedCountry = this.selectedDefaultCountry(value.toLowerCase())
    }
  };

  countries: Country[] = COUNTRIES_FR;
  selectedCountry: Country = this.selectedDefaultCountry();
  phoneNumber = '';
  isValid: boolean = true;
  public ngControl: NgControl;
  
  constructor(private injector: Injector) {}
  compareCountry = (c1: Country, c2: Country) => c1?.iso2 === c2?.iso2;

  ngOnInit(): void {
    this.getCountries();

    try {
      this.ngControl = this.injector.get(NgControl, null);
      if (this.ngControl) {
        this.ngControl.valueAccessor = this;
      }
    } catch (e) {
      console.log(e)
    }
  }
  
  onChange = (_: any) => {};
  onTouched = () => {};

  writeValue(value: any): void {
    if (value) this.phoneNumber = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
    this.onValidate();
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  validate(control: AbstractControl): ValidationErrors | null {
    return this.isValid ? null : { invalidPhone: true };
  }

  getCountries(): Country[] {
    let userLang = 'fr';
  
    if (typeof navigator !== 'undefined') {
      userLang = navigator.language || (navigator.languages && navigator.languages[0]) || 'fr';
    }
  
    const langCode = userLang.split('-')[0]?.toLowerCase();
  
    this.countries = langCode === 'fr' ? COUNTRIES_FR : COUNTRIES_EN;
    return this.countries;
  }
  

  onValidate() {
    if (!this.phoneNumber || !this.selectedCountry) {
      this.isValid = true;
      return;
    }
  
    const parsed = parsePhoneNumberFromString(this.phoneNumber, this.selectedCountry.iso2 as CountryCode);
  
    this.isValid = parsed?.isValid() ?? false;

    if (this.isValid){
      // si je passe parsed je renvoi tout l'object, 
      // je peux afficher les version international etc..
      this.onInputValid(parsed);
      // this.onInputValid(this.phoneNumber);
      this.ngControl.control?.setErrors(null);
    }else {
      this.ngControl.control?.setErrors({ invalidPhone: true });
    }
    this.ngControl.control?.updateValueAndValidity();
  }

  onInputValid(value: PhoneNumber): void {
    this.phoneNumber = value.number;
    this.onChange(value);
    this.onTouched();
  }

  onCountryChange(): void {
    // remettre l input vide
    this.phoneNumber = '';
    // ou faire revalider le numero
    // this.onValidate();
    this.onChange('');
    this.onTouched();
    this.ngControl.control?.updateValueAndValidity();
  }

  selectedDefaultCountry(codeIso: string = 'fr'): Country {
    return this.countries.find(pays => pays.iso2.toLowerCase() === codeIso);
  }

  // dynamicPlaceholder(): string {
  //   if (!this.selectedCountry?.iso2) {
  //     return 'Entrez un numéro';
  //   }
  
  //   try {
  //     const exampleNumber = getExampleNumber(this.selectedCountry.iso2 as CountryCode, examples);
  //     return exampleNumber
  //       ? `${exampleNumber.formatNational()}`
  //       : `+${this.selectedCountry.dialCode}`;
  //   } catch (e) {
  //     return `+${this.selectedCountry.dialCode}`;
  //   }
  // }
}